import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter} from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';

@Component({
    selector: 'app-login-ui',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class AuthComponent implements OnInit {

    loginForm: UntypedFormGroup;
    glob: string;
    @Input() loggedIn: boolean;
    @Input() signingIn: boolean;
    @Input() loginError: string;
    @Input() isCloud: boolean;
    @Output() login = new EventEmitter<{username: string, password: string}>();
    @Output() logout = new EventEmitter();
    logo: string;

    constructor(
        private fb: UntypedFormBuilder
    ) { }

    ngOnInit() {
        this.logo = this.isCloud ? 'assets/logo-ia3.svg' : 'assets/logo.png';
        this.loginForm = this.fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    onSubmit({value}: {value: {username: string, password: string}}) {
        this.login.emit({
            username: value.username,
            password: value.password
        });
    }

    onLogout() {
        this.logout.emit();
    }
}
